<template>
  <div>
    <div id="detailCountBar" style="width:100%;height: 300px" v-loading="loading" v-if="(data && data.length) || loading"></div>
    <el-empty v-else/>
  </div>
</template>

<script>
export default {
  name: "talentCitesBar",
  props:['data','btActive'],
  data() {
    return {
      highBar:null,
      highXData:[],
      highSeriesData:[],
      loading:true,

    }
  },
  watch:{
    data:{
      handler(){
        if (this.data){
          this.data.map((item) => {
            this.highXData.push(item.name);
            this.highSeriesData.push(item.count);
          });
          this.loading = false;
          this.getOption()
        }
      }
    }
  },
  created() {
  },
  methods: {
    getOption() {
      this.highBar = this.$echarts.init(document.getElementById('detailCountBar'))
      let that = this
      let option = {
        title:{
          text:that.title,
          left: '45%',
          top:'4%',
          textStyle:{
            fontWeight:'400',
            fontSize:'14'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        color:['#0751AA'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.highXData,
            axisTick: {
              show: false
            },
            axisLine:{
              lineStyle:{
                color:'#EEEEEE'
              }
            },
            axisLabel:{
              color:'#333333',
              rotate: 30,
              interval: 0,
              formatter:function (val) {
                let name;
                if (val.length>5){
                  name = val.slice(0,5)
                }else {
                  name = val
                }
                return name;
              }
            },

          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine:{
              show: false
            },
            splitLine:{
              lineStyle: {
                color:'#EEEEEE',
                type: "dashed"
              }
            }
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: 12,
            data: this.highSeriesData
          }
        ]
      };
      // this.highBar.off("click");
      this.highBar.setOption(option)
      window.addEventListener('resize', () => {
        this.highBar.resize();
      })
      // this.highBar.getZr().on('click', function (params) {
      //
      // });
    }
  }
}
</script>

<style scoped lang="less">

</style>
